import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-athletic-meet',
  templateUrl: './athletic-meet.component.html',
  styleUrls: ['./athletic-meet.component.scss']
})
export class AthleticMeetComponent implements OnInit {

  athleticImages = [
    '/assets/img/quick-links/athletic-meet/1 (1).jpg',
    '/assets/img/quick-links/athletic-meet/1 (2).jpg',
    '/assets/img/quick-links/athletic-meet/1 (3).jpg',
    '/assets/img/quick-links/athletic-meet/1 (4).jpg',
    '/assets/img/quick-links/athletic-meet/1 (5).jpg',
    '/assets/img/quick-links/athletic-meet/1 (6).jpg',
    '/assets/img/quick-links/athletic-meet/1 (7).jpg',
    '/assets/img/quick-links/athletic-meet/1 (8).jpg',
    '/assets/img/quick-links/athletic-meet/1 (9).jpg',
    '/assets/img/quick-links/athletic-meet/1 (10).jpg',
    '/assets/img/quick-links/athletic-meet/1 (11).jpg',
    '/assets/img/quick-links/athletic-meet/1 (12).jpg',
    '/assets/img/quick-links/athletic-meet/1 (13).jpg',
    '/assets/img/quick-links/athletic-meet/1 (14).jpg',
    '/assets/img/quick-links/athletic-meet/1 (15).jpg',
    '/assets/img/quick-links/athletic-meet/1 (16).jpg',
    '/assets/img/quick-links/athletic-meet/1 (17).jpg',
    '/assets/img/quick-links/athletic-meet/1 (18).jpg',
    '/assets/img/quick-links/athletic-meet/1 (19).jpg',
    '/assets/img/quick-links/athletic-meet/1 (20).jpg',
    '/assets/img/quick-links/athletic-meet/1 (21).jpg',
    '/assets/img/quick-links/athletic-meet/1 (22).jpg',
    '/assets/img/quick-links/athletic-meet/1 (23).jpg',
    '/assets/img/quick-links/athletic-meet/1 (24).jpg',
    '/assets/img/quick-links/athletic-meet/1 (25).jpg',
  ];

  constructor() { }

  ngOnInit(): void { }

}
